import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    padding: 20,
  },

  modalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    maxHeight: '80%',
  },

  modalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
  },

  modalText: {
    fontSize: 14,
    color: '#333',
    marginBottom: 20,
    lineHeight: 22,
  },
  rowButtons: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 16,
    gap: 12,
  },

  buttonHalf: {
    flex: 1,
  },

  termsLink: {
    marginTop: 16,
    color: Colors.RedPallete.red,
    textAlign: 'center',
    textDecorationLine: 'underline',
    fontSize: 14,
  },
});
